import React from "react";

const InnerHero = ({
  title,
  subtitle,
  bgImage,
  breadcrumb = "Home"
}) => {
  return (
    <section
      className="inner-hero"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="inner-hero-overlay">
        <div className="container">
          <div className="inner-hero-content">

            <span className="breadcrumb">
              {breadcrumb} <span>/</span> {title}
            </span>

            <h1>{title}</h1>

            {subtitle && <p>{subtitle}</p>}

            <div className="hero-line"></div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default InnerHero;
